import { useEffect, useContext, useState } from 'react';
import { isEmpty } from 'lodash';
import { useApolloClient } from '@apollo/client';
import { useUser } from '@luigiclaudio/ga-auth-theme';
import { useLocation } from '@gatsbyjs/reach-router';
import { GET_COLORS } from './actionTypes';
import useCreateColorUser from './useCreateColorUser';
import ColorToolsContext from '../components/context/ColorToolsContext';

const useAllColorUserCache = (onCompletedCreateColor = null, onCompleteDeleteColor = null) => {
    const client = useApolloClient();
    const [identity] = useUser();
    const [isErrorLibrary, setIsErrorLibrary] = useState(false);
    const { createColor, deleteColor } = useCreateColorUser(
        onCompletedCreateColor,
        onCompleteDeleteColor,
    );
    const { allColorsUserFromClient, setAllColorsUserFromClient, userFromClient } =
        useContext(ColorToolsContext);
    const { pathname } = useLocation();

    useEffect(() => {
        let cancelled = false;
        const run = async () => {
            try {
                const { data: queryData } = await client.query({
                    query: GET_COLORS,
                });

                if (!cancelled) {
                    setAllColorsUserFromClient(queryData);
                    setIsErrorLibrary(false);
                }
            } catch {
                if (!cancelled) setIsErrorLibrary(true);
            }
        };

        if (identity?.id === userFromClient?.netlifyId && userFromClient?.accountReady) {
            if (!allColorsUserFromClient) {
                run();
            } else {
                const queryData = client.cache.readQuery({
                    query: GET_COLORS,
                });

                if (queryData) {
                    setAllColorsUserFromClient(
                        client.cache.readQuery({
                            query: GET_COLORS,
                        }),
                    );
                }
            }
        }
        return () => {
            cancelled = true;
        };
    }, [userFromClient, identity?.id]);

    useEffect(() => {
        if (allColorsUserFromClient && isEmpty(client.cache.data.data)) {
            client.cache.writeQuery({
                query: GET_COLORS,
                data: {
                    allColors: {
                        __typename: 'Color',
                        data: [...allColorsUserFromClient.allColors.data],
                    },
                },
            });
        }

        if (!isEmpty(client.cache.data.data)) {
            client.cache.readQuery({
                query: GET_COLORS,
            });
        }
    }, [allColorsUserFromClient]);

    return {
        allColorsUserFromClient,
        setAllColorsUserFromClient,
        createColor,
        deleteColor,
        isErrorLibrary,
        user: identity?.id === userFromClient?.netlifyId ? userFromClient : undefined,
        pathname,
        client,
    };
};

export default useAllColorUserCache;
